import { CACHE_CONFIG } from '../api/constants';

/**
 * Get cached insights for an event and options
 */
export const getCachedInsights = (eventId, options = {}) => {
  const { questionType, sessionType } = options;
  const key = `${CACHE_CONFIG.PREFIX}${eventId}_${questionType || 'default'}_${sessionType || 'default'}`;
  const cached = localStorage.getItem(key);
  
  if (!cached) return null;
  
  const { data, timestamp } = JSON.parse(cached);
  if (Date.now() - timestamp > CACHE_CONFIG.TTL) {
    localStorage.removeItem(key);
    return null;
  }
  // Always mark cached data with fromCache: true for downstream consumers
  const cachedWithFlag = { ...data, fromCache: true };
  console.debug('[AIInsights][Cache] Cache hit for', key, { eventId, questionType, sessionType, fromCache: true });
  return cachedWithFlag;
};

/**
 * Cache insights for an event and options
 */
export const cacheInsights = (eventId, data, options = {}) => {
  const { questionType, sessionType } = options;
  const key = `${CACHE_CONFIG.PREFIX}${eventId}_${questionType || 'default'}_${sessionType || 'default'}`;
  localStorage.setItem(key, JSON.stringify({
    data,
    timestamp: Date.now()
  }));
};

/**
 * Clear cache for a specific event
 */
export const clearCache = (eventId) => {
  if (eventId) {
    // Clear specific event cache
    const keys = Object.keys(localStorage);
    keys.forEach(key => {
      if (key.startsWith(CACHE_CONFIG.PREFIX) && key.includes(eventId)) {
        localStorage.removeItem(key);
      }
    });
  } else {
    // Clear all cache
    const keys = Object.keys(localStorage);
    keys.forEach(key => {
      if (key.startsWith(CACHE_CONFIG.PREFIX)) {
        localStorage.removeItem(key);
      }
    });
  }
};

/**
 * Get cache statistics
 */
export const getCacheStats = () => {
  const keys = Object.keys(localStorage);
  const cacheKeys = keys.filter(key => key.startsWith(CACHE_CONFIG.PREFIX));
  return {
    total: cacheKeys.length,
    size: cacheKeys.reduce((total, key) => total + localStorage.getItem(key).length, 0),
    keys: cacheKeys
  };
}; 